import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FC } from 'react';

type WalletConnectProps = {
    className?: string;
};

const WalletConnect: FC<WalletConnectProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'wallet-connect'}
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
        >
            <path
                d="M51.2 78.3c40.8-39.9 106.9-39.9 147.6 0l4.9 4.8c2 2 2 5.2 0 7.2l-16.8 16.4c-1 1-2.7 1-3.7 0l-6.8-6.6c-28.4-27.8-74.6-27.8-103 0l-7.2 7.1c-1 1-2.7 1-3.7 0L45.8 90.8c-2-2-2-5.2 0-7.2l5.4-5.3zm182.3 34l14.9 14.6c2 2 2 5.2 0 7.2l-67.4 66c-2 2-5.3 2-7.4 0l-47.8-46.8c-.5-.5-1.3-.5-1.8 0l-47.8 46.8c-2 2-5.3 2-7.4 0l-67.4-66c-2-2-2-5.2 0-7.2l14.9-14.6c2-2 5.3-2 7.4 0l47.8 46.8c.5.5 1.3.5 1.8 0l47.8-46.8c2-2 5.3-2 7.4 0l47.8 46.8c.5.5 1.3.5 1.8 0l47.8-46.8c2.3-2 5.6-2 7.6 0z"
                fill="#3B99FC"
            />
        </svg>
    );
};

export default WalletConnect;
